import {Component, Input} from '@angular/core';
import {BookableService} from "../../model/bookableService";
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'app-service-renderer',
  templateUrl: './service-renderer.component.html',
  styleUrls: ['./service-renderer.component.css']
})
export class ServiceRendererComponent{

    @Input() formGroup: FormGroup;
    @Input() useCheckboxes: boolean = false;
    @Input() services: BookableService[];
    @Input() categoryId: string;
    @Input() groupName: string;
    @Input() digitizationServiceApproximatePricing: { [key: string]: string };
}
